module.exports = __webpack_public_path__ + "img/icon_data_source_changed.3ee3dc83.svg";